var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.consultarPagos }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-danger btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.pdf }
            },
            [
              _c("i", { staticClass: "fa fa-file-pdf-o" }),
              _c("span", [_vm._v("PDF")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select" }, [
                  _c("div", { staticClass: "select-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_fecha,
                            expression: "form.tipo_fecha"
                          }
                        ],
                        attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.form,
                                "tipo_fecha",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.changePersonalizada
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "F" } }, [
                          _vm._v("A la fecha")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "H" } }, [
                          _vm._v("Hoy")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "A" } }, [
                          _vm._v("Ayer")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "P" } }, [
                          _vm._v("Personalizada")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "tipo_fecha" } }, [
                      _vm._v("Tipo de fecha")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-4"
                },
                [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "auto-close": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione una fecha..."
                          },
                          model: {
                            value: _vm.form.desde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "desde", $$v)
                            },
                            expression: "form.desde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Desde")])
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "col-xs-12 col-md-4"
                },
                [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "auto-close": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione una fecha..."
                          },
                          model: {
                            value: _vm.form.hasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hasta", $$v)
                            },
                            expression: "form.hasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Hasta")])
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "cliente",
                          options: _vm.clientes,
                          label: "descripcion"
                        },
                        on: { input: _vm.inputCliente },
                        model: {
                          value: _vm.selectedCliente,
                          callback: function($$v) {
                            _vm.selectedCliente = $$v
                          },
                          expression: "selectedCliente"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "cliente" } }, [
                        _vm._v("Cliente")
                      ])
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.comprobantes, function(comprobante, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-info btn--text",
                            on: {
                              click: function($event) {
                                return _vm.irAComprobante(comprobante)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-eye" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(comprobante.numero_documento))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            comprobante.vendedor !== null
                              ? comprobante.vendedor.nombre
                              : ""
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(comprobante.nombre_cliente))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .moment(new Date(comprobante.fecha_emision))
                              .format("YYYY-MM-DD")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c("table", [
                            _vm._m(2, true),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(comprobante.formas_pago, function(
                                formaPago,
                                index2
                              ) {
                                return _c(
                                  "tr",
                                  {
                                    key: index2,
                                    class: {
                                      "tr--canceled": _vm.pagoExpirado(
                                        formaPago
                                      ),
                                      "tr--pending": _vm.pagoExpectante(
                                        formaPago
                                      )
                                    }
                                  },
                                  [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(formaPago.forma_pago.descripcion)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(formaPago.plazo) +
                                          " " +
                                          _vm._s(formaPago.unidad_tiempo)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(formaPago.fecha_maxima_pago)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.diasRestantes(formaPago))
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("input-field", {
                            attrs: {
                              vMoney: "",
                              format: _vm.money,
                              id: "subtotal" + index,
                              readonly: ""
                            },
                            model: {
                              value: comprobante.subtotal,
                              callback: function($$v) {
                                _vm.$set(comprobante, "subtotal", $$v)
                              },
                              expression: "comprobante.subtotal"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("input-field", {
                            attrs: {
                              vMoney: "",
                              format: _vm.money,
                              id: "valor_iva" + index,
                              readonly: ""
                            },
                            model: {
                              value: comprobante.valor_iva,
                              callback: function($$v) {
                                _vm.$set(comprobante, "valor_iva", $$v)
                              },
                              expression: "comprobante.valor_iva"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("input-field", {
                            attrs: {
                              vMoney: "",
                              format: _vm.money,
                              id: "valorTotal" + index,
                              readonly: ""
                            },
                            model: {
                              value: comprobante.valor_total,
                              callback: function($$v) {
                                _vm.$set(comprobante, "valor_total", $$v)
                              },
                              expression: "comprobante.valor_total"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("input-field", {
                            attrs: {
                              vMoney: "",
                              format: _vm.money,
                              id: "totalPagado" + index,
                              readonly: ""
                            },
                            model: {
                              value: comprobante.total_pagado,
                              callback: function($$v) {
                                _vm.$set(comprobante, "total_pagado", $$v)
                              },
                              expression: "comprobante.total_pagado"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("input-field", {
                            attrs: {
                              vMoney: "",
                              format: _vm.money,
                              id: "saldo" + index,
                              readonly: ""
                            },
                            model: {
                              value: comprobante.saldo,
                              callback: function($$v) {
                                _vm.$set(comprobante, "saldo", $$v)
                              },
                              expression: "comprobante.saldo"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", [
                _vm._m(3),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.totalComprobantes) +
                          "\n                  "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.moneyFormat(_vm.subtotal)) +
                          "\n                  "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.moneyFormat(_vm.valorIva)) +
                          "\n                  "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.moneyFormat(_vm.valorTotal)) +
                          "\n                  "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.moneyFormat(_vm.totalPagado)) +
                          "\n                  "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.moneyFormat(_vm.saldo)) +
                          "\n                  "
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Alertas de pago")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Número de comprobante")]),
        _vm._v(" "),
        _c("th", [_vm._v("Vendedor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de emisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Pagos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subtotal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Iva")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total pagado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Forma de pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Plazo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha máxima de pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Diferencia de días")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Total de comprobantes")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subtotal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor IVA")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total pagado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33aa44d5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33aa44d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Alertas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-33aa44d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Alertas.vue
// module chunks = 0